var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3395 4.84999C16.7625 4.42712 17.0001 3.85354 17.0002 3.25544C17.0003 2.65733 16.7628 2.0837 16.3399 1.66072C15.917 1.23774 15.3434 1.00008 14.7453 1C14.1472 0.999925 13.5736 1.23745 13.1506 1.66032L2.47358 12.3398C2.28783 12.525 2.15046 12.753 2.07357 13.0038L1.01675 16.4855C0.996072 16.5546 0.99451 16.6281 1.01223 16.6981C1.02995 16.7681 1.06629 16.832 1.11739 16.8831C1.16849 16.9341 1.23245 16.9703 1.30248 16.9879C1.37251 17.0055 1.446 17.0039 1.51516 16.9831L4.99764 15.927C5.24818 15.8508 5.47619 15.7143 5.66165 15.5294L16.3395 4.84999Z",
    stroke: "#7C87FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4012 3.40036L14.6013 6.60043",
    stroke: "#7C87FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPen);
export default __webpack_public_path__ + "static/media/icon-pen.77dbf6d275018d15b1e6e3f34b50de16.svg";
export { ForwardRef as ReactComponent };